import api from "./api";

// Lectura COMPARTIDA de GET /follow-up/tasks?status=open (Centro de Llamadas, 2026-10-27). La barra «Clientes por contactar» y la tarjeta
// «Cliente de la llamada» pedían la MISMA consulta cada una por su lado; así dos pedidos a la vez (o seguidos, dentro de 5 s) comparten
// una sola respuesta. Solo lectura: no cambia qué se pregunta ni a qué endpoint, y un fallo no se guarda (el siguiente intento vuelve a pedir).
const FRESH_MS = 5000;
let inflight = null;
let last = { at: 0, data: null };
// Alcance de sesión (usuario + equipo). La caché y el pedido en vuelo SOLO valen para el alcance con el que se pidieron: al cambiar la
// autenticación (logout/login, otro equipo) se descarta todo y la respuesta en vuelo del usuario anterior se rechaza. Sin alcance
// (sin sesión conocida) NO se comparte ni se guarda nada: cada llamada pide la suya (fail-cerrado).
let scope = null;
let gen = 0;

export function scopeFromUser(user) {
  if (!user) return null;
  const id = user._id || user.id;
  return id ? `${id}|${user.team_id || ""}` : null;
}

export function setOpenTasksScope(next) {
  const n = next || null;
  if (n === scope) return;
  scope = n; gen += 1; inflight = null; last = { at: 0, data: null };
}

export function fetchOpenTasks() {
  const req = () => api.get("/follow-up/tasks", { params: { status: "open" } });
  if (!scope) return req();
  if (inflight) return inflight;
  if (last.data && Date.now() - last.at < FRESH_MS) return Promise.resolve(last.data);
  const myGen = gen;
  const p = req()
    .then((r) => {
      if (myGen !== gen) throw new Error("openTasks: la sesión cambió, respuesta descartada");
      last = { at: Date.now(), data: r }; return r;
    })
    .finally(() => { if (inflight === p) inflight = null; });
  inflight = p;
  return p;
}

export function resetOpenTasksCache() { inflight = null; last = { at: 0, data: null }; }
